/*
    FILE

    - the File class is the base node blueprint that defines files AND folders
       which make up File Systems
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

// import Faker from 'faker';

//------------------------------------------------------------
// INSTANCE VARS
//------------------------------------------------------------

const DEFAULTS = {
    // id: Faker.random.uuid(),
    uuid: null,
    // id: null,
    name: null,
    path: null,
    children: null, // [] if breaks
    core: false,
    component: null, // or MediaViewer if file
    content: null, // either a string, blob or asset url to load. --- should this move to data?
    created: Date.now(), // not really important
    deletable: true,
    encrypted: false,
    ext: '', // exe, jpg,
    gridId: null,
    hidden: false,
    icon: '',
    initProp: null, // rename to data
    modified: Date.now(), // not really important
    // moveable: true, // stays where it is placed via the fileSystem template
    draggable: true, // is the ICON draggable
    password: false,
    props: {},
    readOnly: false,
    showInTaskbar: true,
    showInTaskbarPins: false,
    showInTaskbarSystemTray: false,
    splashScreen: false,
    size: 0,
    subFiles: null,
    type: 'Folder',

    windowData: {
        active: true,
        delayOpen: 0, // should these be in window?
        delayClose: 0, // *
        draggable: true,
        duplicable: false,
        //el: null, // *new* added on mount
        lockAspectRatio: false,
        minimizable: true,
        minimized: null,
        maximizable: true,
        maximized: null,
        width: 780,
        height: 568,
        minWidth: 300,
        minHeight: 350,
        maxWidth: 9999999,
        maxHeight: 9999999,
        resizable: true,
        x: null,
        y: null,
        z: 0,
    }
}

//------------------------------------------------------------
// RANDOM ID
// https://gist.github.com/gordonbrander/2230317
//------------------------------------------------------------

const randId = () => {
    return Math.random().toString(36).substr(2, 9);
}

//------------------------------------------------------------
// FILE CLASS
// https://stackoverflow.com/questions/31342290/es6-classes-default-value
//------------------------------------------------------------

export default class File {
    constructor(options = {}) {
        Object.assign(this.data = {}, DEFAULTS, options);
        Object.assign(this.data.windowData = {}, DEFAULTS.windowData, options.windowData);

        // the ID applies to the gameObject eg. FileSystem, Recycle Bin
        // if duplicable, the id will remain the same (eg. FileSystem)
        this.data.id = randId();

        // TODO: check ids - make sure there's no duplicates

        // if (options.core) {
        //     this.data.moveable = false;
        //     this.data.deletable = false;
        //     this.data.encrypted = true;
        // }

        return this.data;
    }
}